import React, { Component } from "react";
import PropTypes from "prop-types";

import Spinner from "@template/components/Spinner";
import Fade from "@template/components/CountrySelector/Fade";
import Backdrop from "@template/components/CountrySelector/Backdrop";
import Form from "@template/components/CountrySelector/Form";
import Container from "@template/components/CountrySelector/Container";
import getAlternateUrls from "../../helpers/getAlternateUrls";

class CountrySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { firstOpen: true, alternateUrls: {} };
  }

  componentDidMount() {
    this.setState({ alternateUrls: getAlternateUrls() });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ lastActiveElement: document.activeElement });
    }
  }

  handleClose = () => {
    const { lastActiveElement } = this.state;
    const { onClose } = this.props;

    onClose();
    lastActiveElement.focus();
    this.setState({ firstOpen: true });
  };

  onCountryChange = (country, defaultLanguage) => {
    this.props.onCountryChange(country, defaultLanguage);
    this.setState({ firstOpen: false });
  };

  render() {
    const {
      country,
      hasSetCurrencyError,
      hasVoucherError,
      isLoading,
      isOpen,
      noOfProductsInBag,
      onSubmit,
      regionalStore
    } = this.props;

    return (
      <Fade isActive={isOpen}>
        <Backdrop />
        <Container
          onClose={this.handleClose}
          isLoading={isLoading}
          withError={hasVoucherError || hasSetCurrencyError}
        >
          {isLoading || country == null ? (
            <Spinner size="x-large" />
          ) : (
            <Form
              {...country}
              hasSetCurrencyError={hasSetCurrencyError}
              hasVoucherError={hasVoucherError}
              noOfProductsInBag={noOfProductsInBag}
              onClose={this.handleClose}
              onCountryChange={this.onCountryChange}
              onSubmit={onSubmit}
              regionalStore={regionalStore}
              storeUrl={this.state.alternateUrls[country.lang]}
              firstOpen={this.state.firstOpen}
            />
          )}
        </Container>
      </Fade>
    );
  }
}

CountrySelector.propTypes = {
  country: PropTypes.object,
  hasVoucherError: PropTypes.bool,
  hasSetCurrencyError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  noOfProductsInBag: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  regionalStore: PropTypes.shape({
    countryCode: PropTypes.string,
    storeCode: PropTypes.string,
    siteId: PropTypes.number,
    currency: PropTypes.string,
    language: PropTypes.string,
    countryName: PropTypes.string,
    sizeSchema: PropTypes.string
  })
};

export default CountrySelector;
